<div class="loading-spinner">
  <i class="fa-regular fa-spinner-third fa-spin loading-spinner-icon" aria-hidden="true"></i>
</div>
